import React from 'react'

import './header.css';
function header(Kitinfo) {
  return (
    <div className='header'>
      <div className="s1" style={{ textAlign: 'left' }}>
        <h5>Report</h5>
        <h5 className="s2">Microbiome Analysis</h5>
      </div>

      <div className="s1" style={{ textAlign: 'center' }}>
        <h5>Kit</h5>
        <h5 className="s2">{Kitinfo.Kitinfo.kit_code}</h5>

      </div>

      <div className="s1" style={{ textAlign: 'right' }}>

        <h5>Date</h5>
        <h5 className="s2">{Kitinfo.Kitinfo.analysis_at}</h5>
      </div>
    </div>
  )
}

export default header
